import { BaseConsentService } from "./BaseConsentService.ts"
import { CookieCategory } from "./types.ts"

class WebCookieConsentServiceClass extends BaseConsentService {
  hasConsent(category: CookieCategory): boolean {
    if (globalThis.Cookiebot?.consent) {
      return !!globalThis.Cookiebot.consent[category]
    } else {
      return super.hasConsent(category)
    }
  }

  runOnceCookieCategoryAccepted(
    category: CookieCategory,
    callback: () => void,
  ) {
    if (this.hasConsent(category)) {
      callback()
      return
    }

    const listener = () => {
      if (this.hasConsent(category)) {
        callback()
      }
    }

    window.addEventListener("CookiebotOnAccept", listener, false)
    window.addEventListener("CookiebotOnDecline", listener, false)
  }

  openPreferencesModal() {
    globalThis.Cookiebot?.renew()
  }

  init() {
    const persistConsent = () => {
      const consent = globalThis.Cookiebot?.consent
      if (consent) {
        this.storeConsent(consent)
      }
    }

    window.addEventListener("CookiebotOnAccept", persistConsent, false)
    window.addEventListener("CookiebotOnConsentReady", persistConsent, false)
    window.addEventListener("CookiebotOnDecline", persistConsent, false)
  }
}

export const CookieConsentService = new WebCookieConsentServiceClass()
